import React from 'react';

import { Container } from './styles';

function BreakLine() {
  return <Container />;
}

export default BreakLine;
